export function getProjectPublicDirectoryPath() {
  return `${process.env.PUBLIC_URL}/projects/${process.env.REACT_APP_PROJECT}/`
}

export function getAssetPath(fileName: string): string {
  return `${getProjectPublicDirectoryPath()}${fileName}`
}
